import React from 'react';

const IconArticle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    role="img"
    aria-labelledby="articleTitle">
    <title id="articleTitle">Article</title>
    <path
      fill="currentColor"
      d="M19 3H5c-1.1 0-2 .9-2 2v14c0 
         1.1.9 2 2 2h14c1.1 0 
         2-.9 2-2V5c0-1.1-.9-2-2-2Zm-2 
         14H7v-2h10v2Zm0-4H7v-2h10v2Zm0-4H7V7h10v2Z"
    />
  </svg>
);

export default IconArticle;
